import api from './api';

export const putAsync = <TData = any, TResponse = any>(
    url: string,
    data?: TData,
): Promise<APIResponse<TResponse>> => {
    return api.put(url, data);
};
